import { gql } from '@apollo/client';

export const QueryLoadFarmSearchResultCount = gql`
  query LoadFarmSearchResultCount(
    $nodeId: Int!
    $page: Int!
    $filter: FilterInputGrouped
    $searchQuery: String!
  ) {
    farmSearch(
      nodeId: $nodeId
      searchQuery: $searchQuery
      filter: $filter
      page: $page
    ) {
      total
    }
  }
`;
